module.exports = __webpack_public_path__ + "img/abstract-network.fa43353a.png";